module.exports = __webpack_public_path__ + "static/media/Ronald Reagan - 1980.e93d2a20.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/Ronald Reagan - 1980.jpg
// module id = 542
// module chunks = 0